import { useTranslation } from 'react-i18next'
import { Alpha3Code } from 'i18n-iso-countries'

import { CardContent } from '@percent/lemonade'
import { PaymentMethod, UnableToPayReasons } from '@percent/admin-dashboard/api/types'
import { PaymentTypeWithButton } from './PaymentTypeWithButton'

export function UnableToPayView({
  paymentMethod,
  refresh,
  organisationCountryCode
}: Readonly<{
  paymentMethod: PaymentMethod
  refresh: VoidFunction
  organisationCountryCode: Alpha3Code
}>) {
  const { t } = useTranslation()

  return (
    <>
      <PaymentTypeWithButton
        title={t('typography.paymentMethod')}
        text={t('typography.unableToPay')}
        paymentMethod={paymentMethod}
        refresh={refresh}
        organisationCountryCode={organisationCountryCode}
      />
      <CardContent title={t('typography.reason')} testId="unable-to-pay-details-reason">
        {t(`dropdown.unpayableOrganisation.${paymentMethod.reason as UnableToPayReasons}`) ||
          t('typography.noneSupplied')}
      </CardContent>
    </>
  )
}
